import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const CompanyIdentities = React.lazy(() => import('./index'));
const CompanyIdentityTable = React.lazy(() => import('./companyIdentityTable'));
const CompanyIdentity = React.lazy(() => import('./companyIdentity'));
const CompanyIdentityDetail = React.lazy(() => import('./companyIdentityDetail'));

export const useCompanyIdentityRoutes = () => {

    return (
        <Route path="companyIdentities" element={<Suspense fallback={<div>منتظر باشید...</div>}><CompanyIdentities /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CompanyIdentityTable/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><CompanyIdentity/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CompanyIdentityDetail/></Suspense> } />
            </Route>
        </Route>
    )
}